import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet } from 'react-native';
import { getProps, getStyles } from './utils';

function Text(props) {
  const nativeProps = getProps(props);
  const originalStyle = StyleSheet.flatten(props.style);

  return (
    <span tabIndex={props.tabIndex} testID={props.testID} id={ props.children } className={`${props.size} ${props.type}`} style={originalStyle}>
      { props.children }
    </span>
  );
}

Text.defaultProps = {
  size: 'normal',
  type: 'primary',
  testID:null
};

Text.propTypes = {
  disabled: PropTypes.bool,
  size: PropTypes.oneOf([
    'xxsmall',
    'xsmall',
    'small',
    'normal',
    'large', // TODO: deprecated?
    'header1',
    'header2',
    'header3',
    'header4',
  ]),
  // type: PropTypes.oneOf([
  //   'primary',
  //   'secondary',
  // ]),
  align: PropTypes.oneOf([
    'center',
    'left',
    'right',
  ]),
  style: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

export default Text;
